import React from 'react'
import FinancialLotteryReportList from '../components/FinancialLotteryReportList'
import FinancialReportShell from '../components/FinancialReportShell'

const FinancialReportPendingPage: React.FC = () => {
  return (
    <FinancialReportShell activeTab="pending">
      <FinancialLotteryReportList mode="pending" />
    </FinancialReportShell>
  )
}

export default FinancialReportPendingPage
